/**
 * Command functions for ribbon buttons
 */

/**
 * Show task pane
 */
function showTaskPane(event: Office.AddinCommands.Event) {
  debugger;
  // Open task pane
  Office.context.ui.displayDialogAsync(
    'https://localhost:3000/taskpane.html',
    { height: 50, width: 30 },
    (result) => {
      if (result.status === Office.AsyncResultStatus.Failed) {
        console.error('Failed to open task pane:', result.error);
      }
    }
  );

  event.completed();
}

/**
 * Quick save email (without showing UI)
 */
function quickSaveEmail(event: Office.AddinCommands.Event) {
  // This would implement a quick save with auto-detection
  // For now, just show the task pane
  showTaskPane(event);
}

// Register functions
Office.actions.associate('showTaskPane', showTaskPane);
Office.actions.associate('quickSaveEmail', quickSaveEmail);
